<template>
  <v-card>
    <v-card-title class="headline">
      <layout-no-padding>
        <v-flex xs12>
          <span>
            Create PDFs?
            <span class="grey--text subheading"></span>
          </span>
        </v-flex>
        <v-flex
          v-if="!docketAdjustment"
          xs12
          class="grey--text title"
        >This action will affect {{selectedCount}} document(s).</v-flex>
      </layout-no-padding>
    </v-card-title>
    <v-form>
      <v-card-text v-if="!docketAdjustment">
        <v-switch
          v-if="$route.name != 'docket'"
          color="indigo"
          label="Include Trips"
          v-model="pdfIncludeTrips"
        ></v-switch>
        <!-- <v-switch 
                xs-12
                v-if="$route.name == 'docket'"
                color="indigo" 
                label="Include Travel and Breaks" 
                v-model="pdfIncludeTravelBreaks">
        </v-switch>-->
        <v-switch
          xs-12
          v-if="$route.name == 'docket' && !docketAdjustment"
          color="indigo"
          label="Include Hours and Mass"
          v-model="pdfIncludeHoursMass"
        ></v-switch>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" flat @click="close()">No</v-btn>
        <v-btn color="green darken-1" flat @click="makePdfs()" :loading="loading">Yes</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import DocketService from '@/services/requests/docketService'
import ApprovedBillLineService from '@/services/requests/approvedBillLineService'
import RctiService from '@/services/requests/rctiService'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import FormatDates from '@/services/mixins/formatDates'
import BuildTripQuery from '@/services/mixins/buildTripQuery'
export default {
  mixins: [FormatDates, BuildTripQuery],
  data() {
    return {
      //pdfInvoiceDialog: false,
      pdfIncludeTrips: true,
      pdfIncludeHoursMass: true,
      pdfIncludeTravelBreaks: false,
      invoiceTrips: [],
      loading: false,
      topOffset: 40,
      leftSide: 20,
      rightSide: 570,
      lineHeight: 17,
      colWidth: 110,
      today: new Date()
    }
  },
  methods: {
    close() {
      this.pdfInvoiceDialog = false
      this.pdfDialog = false
      this.$emit('closed')
    },
    async getTripsWithQuery() {
      var query = this.buildQuery()
      query.pagination = this.$store.state.trips.pagination
      query.type = 'pdf'
      return DocketService.getUnconfirmedTrips(query)
        .then(result => {
          return result.data.result
        })
        .catch(err => {
          console.log(err)
          return null
        })
    },
    getTrips(invoiceId, payload) {
      const billingService = payload.isApproved
        ? ApprovedBillLineService['getApprovedBillLinesByBill']
        : DocketService['getTripsByBill']
      const service =
        this.$route.name == 'billing'
          ? billingService
          : DocketService['getTripsByRcti']
      return service(invoiceId, payload)
        .then(async result => {
          return result.data.result
        })
        .catch(err => {
          this.loading = false
          this.snackError()
          console.log(err)
          return null
        })
    },
    makePdfs() {
      if (this.$route.name == 'rcti' || this.$route.name == 'billing') {
        this.makeInvoicePdfs()
      }
      if (this.$route.name == 'docket') {
        if (!this.docketAdjustment) {
          this.makeTripsPdf()
        } else {
          if (this.docketAdjustment.adjustRcti)
            this.makeDocketPdf('sub-contractor')
          if (this.docketAdjustment.adjustBill) this.makeDocketPdf('client')
        }
      }
    },
    async makeInvoicePdfs() {
      this.loading = true
      for (var invoice of this.selected) {
        //console.log("Make PDF: ", invoice);
        var invoice = await this.invoiceToPdf(invoice, this.pdfIncludeTrips)
      }
      this.loading = false
    },
    async makeTripsPdf() {
      this.loading = true
      let doc = new jsPDF('l', 'pt')
      let trips = []
      if (this.selectedAll) {
        trips = await this.getTripsWithQuery()
      } else {
        trips = this.selected
      }

      doc = await this.createTripsPdf(doc, trips)
      doc.save(`SelectedTrips.pdf`)
      this.loading = false
      this.pdfInvoiceDialog = false
    },

    async makeDocketPdf(type) {
      this.loading = true
      var docket = await this.docketToPdf(this.docketAdjustment, type)
      this.loading = false
    },

    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },

    async docketToPdf(docket, type) {
      console.log(docket)

      let doc = new jsPDF('l', 'pt')
      var pageSize = doc.internal.pageSize
      var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()
      var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()

      //HEADER
      doc.setFontSize(22)
      doc.text(
        pageWidth - 32,
        this.topOffset,
        `Docket ${this.getProperCase(docket.type)} (${type})`,
        { align: 'right' }
      )
      doc.setFontSize(12)
      doc.text(
        pageWidth - 45,
        this.topOffset + this.lineHeight,
        `Reference: ${docket.externalRef}`,
        { align: 'right' }
      )
      doc.text(
        pageWidth - 45,
        this.topOffset + this.lineHeight * 2,
        `Date: ${this.makeShortDate(docket.date)}`,
        { align: 'right' }
      )
      doc.setFontSize(16)
      var name =
        type == 'client'
          ? docket.site.project.client.name
          : docket.vehicle.contractor.name
      doc.text(this.leftSide, this.topOffset, name, { align: 'left' })
      doc.setFontSize(12)
      doc.text(
        this.leftSide,
        this.topOffset + this.lineHeight,
        `Driver: ${docket.driver.name}`,
        { align: 'left' }
      )
      doc.text(
        this.leftSide,
        this.topOffset + this.lineHeight * 2,
        `Vehicle: ${docket.vehicle.name}`,
        { align: 'left' }
      )
      doc.text(
        this.leftSide,
        this.topOffset + this.lineHeight * 3,
        `Site: ${docket.site.name} (${docket.site.project.name})`,
        { align: 'left' }
      )

      //BODY
      var columns = [
        { title: 'Spoil', dataKey: 'spoilName' },
        { title: 'Tip', dataKey: 'tipName' },
        { title: 'Mass', dataKey: 'mass' },
        { title: 'Hours', dataKey: 'hours' },
        { title: 'Qty', dataKey: 'qty' },
        { title: 'Notes', dataKey: 'notes' },
        { title: 'Total', dataKey: 'total' }
      ]

      var rows = docket.trips.map(obj => {
        if (type == 'sub-contractor')
          obj.total =
            '$' + this.numberWithCommas(Number(obj.costTotal).toFixed(2))
        if (type == 'client')
          obj.total =
            '$' + this.numberWithCommas(Number(obj.sellTotal).toFixed(2))
        obj.spoilName = obj.spoil.name
        obj.tipName = obj.tip.name
        obj.mass = obj.siteWeight
        return obj
      })

      doc.autoTable(columns, rows, {
        theme: 'grid',
        styles: { halign: 'left' },
        headStyles: { fillColor: [220, 220, 220], halign: 'center' },
        margin: {
          left: this.leftSide,
          top: this.topOffset + this.lineHeight * 5
        },
        columnStyles: {
          total: { halign: 'right' },
          hours: { halign: 'right' },
          qty: { halign: 'right' },
          mass: { halign: 'right' }
        }
      })

      //FOOTER
      var total =
        type == 'client'
          ? await this.calculateTotal(rows, 'sellTotal')
          : await this.calculateTotal(rows, 'costTotal')
      doc.setFontSize(16)
      doc.line(this.leftSide, pageHeight - 60, pageWidth - 45, pageHeight - 60)
      doc.text(
        pageWidth - 45,
        pageHeight - 40,
        `Total: $${this.numberWithCommas(Number(total).toFixed(2))}`,
        { align: 'right' }
      )
      doc.save(`Adjust_${name}_${docket.externalRef}.pdf`)
      this.close()
      return
    },

    async invoiceToPdf(invoice, includeTrips) {
      //console.log("INVOICE DATA: ",invoice);
      let invoiceNo = !!invoice.externalRef ? invoice.externalRef : invoice.id
      var invoiceSubtotal = 0
      let rows = []
      let filePrefix = ''
      let invoiceText = ''
      let invoiceFrom = ''
      let invoiceFromABN = ''
      let invoiceTo = ''
      let invoiceToABN = ''
      var projectName = ''
      let columns = [
        { title: 'Description', dataKey: 'description' },
        { title: 'Amount', dataKey: 'costTotal' }
      ]
      rows = rows.map(obj => {
        obj.costTotal =
          '$' + this.numberWithCommas(Number(obj.costTotal).toFixed(2))
        obj.sellTotal =
          '$' + this.numberWithCommas(Number(obj.sellTotal).toFixed(2))
        return obj
      })

      if (this.$route.name == 'rcti') {
        projectName = invoice.project.name
        rows = invoice.rctiLines

        if (Number(invoice.total) < 0) {
          invoiceText = 'Recipient Created Adjustment Note'
        } else {
          invoiceText = 'Recipient Created Tax Invoice'
        }
        invoiceFrom = invoice.contractor.name
        invoiceFromABN = invoice.contractor.abn
        invoiceFromABN = invoiceFromABN.replace(/\s/g, '')
        invoiceFromABN =
          invoiceFromABN.slice(0, 2) +
          ' ' +
          invoiceFromABN.slice(2, 5) +
          ' ' +
          invoiceFromABN.slice(5, 8) +
          ' ' +
          invoiceFromABN.slice(8, 11)
        invoiceTo = 'State Road Constructions'
        invoiceToABN = '77 156 503 883'
        invoiceSubtotal = await this.calculateTotal(rows, 'costTotal')
        filePrefix = `RCTI`
        //filePrefix = `RCTI${invoiceFrom}`
        columns = [
          { title: 'Description', dataKey: 'description' },
          { title: 'Amount', dataKey: 'costTotal' }
        ]
      }
      if (this.$route.name == 'billing') {
        projectName = `${invoice.project.name} - ${invoice.site.name}`
        rows = invoice.billLines
        if (invoice.type == 'CREDIT') {
          invoiceText = 'Adjustment Note'
        } else {
          invoiceText = 'Tax Invoice'
        }
        invoiceFrom = 'State Road Constructions'
        invoiceFromABN = '77 156 503 883'
        invoiceTo = invoice.client.name
        invoiceToABN = invoice.client.abn
        invoiceSubtotal = await this.calculateTotal(rows, 'sellTotal')
        filePrefix = `Invoice_${invoiceTo}`
        columns = [
          { title: 'Description', dataKey: 'description' },
          { title: 'Amount', dataKey: 'sellTotal' }
        ]
      }

      var invoiceGST = invoiceSubtotal / 10
      var invoiceTotal = invoiceSubtotal + invoiceGST
      //invoice.total = invoiceSubtotal+invoiceGST;
      invoiceSubtotal =
        '$' + this.numberWithCommas(Number(invoiceSubtotal).toFixed(2))
      invoiceGST = '$' + this.numberWithCommas(Number(invoiceGST).toFixed(2))
      invoiceTotal =
        '$' + this.numberWithCommas(Number(invoiceTotal).toFixed(2))
      let doc = new jsPDF('p', 'pt')

      doc.setFontSize(16)
      doc.text(this.centerAlign, this.topOffset, invoiceFrom, {
        align: 'center'
      })
      doc.setFontSize(14)
      doc.text(
        this.centerAlign,
        this.topOffset + this.lineHeight - 2,
        `ABN: ${invoiceFromABN}`,
        { align: 'center' }
      )
      doc.setFontSize(16)
      doc.text(
        this.centerAlign,
        this.topOffset + this.lineHeight * 2,
        `${invoiceText}: # ${invoiceNo}`,
        { align: 'center' }
      )
      doc.text(
        this.centerAlign,
        this.topOffset + this.lineHeight * 4,
        `Job: ${projectName}`,
        { align: 'center' }
      )

      doc.setFontSize(14)
      doc.line(
        this.leftSide,
        this.topOffset + this.lineHeight * 4.5,
        this.rightSide,
        this.topOffset + this.lineHeight * 4.5
      )

      doc.text(
        this.leftSide,
        this.topOffset + this.lineHeight * 6,
        `To: ${invoiceTo}`
      )
      doc.text(
        this.leftSide,
        this.topOffset + this.lineHeight * 7,
        `ABN: ${invoiceToABN}`
      )
      doc.text(
        this.leftSide,
        this.topOffset + this.lineHeight * 8,
        `Date: ${this.makeShortDate(invoice.date)}`
      )
      doc.text(
        this.leftSide,
        this.topOffset + this.lineHeight * 9,
        `Billing Period: ${this.billingPeriod}`,
        { align: 'left' }
      )
      rows = rows.map(obj => {
        obj.costTotal =
          '$' + this.numberWithCommas(Number(obj.costTotal).toFixed(2))
        obj.sellTotal =
          '$' + this.numberWithCommas(Number(obj.sellTotal).toFixed(2))
        return obj
      })
      doc.autoTable(columns, rows, {
        theme: 'grid',
        styles: { halign: 'left' },
        headStyles: { fillColor: [220, 220, 220], halign: 'center' },
        margin: {
          left: this.leftSide,
          top: this.topOffset + this.lineHeight * 11
        },
        columnStyles: {
          costTotal: { halign: 'right' },
          sellTotal: { halign: 'right' }
        }
      })
      doc.setFontSize(14)
      doc.text(
        this.rightSide,
        this.topOffset + this.lineHeight * 24,
        `Sub-total: ${invoiceSubtotal}`,
        { align: 'right' }
      )
      doc.text(
        this.rightSide,
        this.topOffset + this.lineHeight * 25,
        `GST: ${invoiceGST}`,
        { align: 'right' }
      )
      doc.setFontSize(18)
      doc.text(
        this.rightSide,
        this.topOffset + this.lineHeight * 27,
        `Total: ${invoiceTotal}`,
        { align: 'right' }
      )

      doc.setFontSize(14)
      doc.line(
        this.leftSide,
        this.topOffset + this.lineHeight * 28,
        this.rightSide,
        this.topOffset + this.lineHeight * 28
      )
      doc.text(
        this.leftSide,
        this.topOffset + this.lineHeight * 30,
        `Notes: ${!!invoice.invoiceNotes ? invoice.invoiceNotes : ''}`,
        { maxWidth: 500 }
      )
      doc.setFontSize(8)
      doc.text(
        this.centerAlign,
        this.topOffset + this.lineHeight * 45,
        'Please contact State Road Contsructions within 7 days of receipt with any enquiries at',
        { align: 'center' }
      )
      doc.text(
        this.centerAlign,
        this.topOffset + this.lineHeight * 46,
        'info@stateroadconstructions.com.au',
        { align: 'center' }
      )

      doc.save(`${filePrefix}${invoiceNo}_${invoiceFrom}.pdf`)

      if (!includeTrips) {
        this.pdfInvoiceDialog = false
        return
      }
      const payload =
        this.$route.name == 'billing'
          ? { isApproved: invoice.isApproved }
          : { isApproved: false }
      var trips = await this.getTrips(invoice.id, payload)

      doc = new jsPDF('l', 'pt')
      doc = await this.createTripsPdf(doc, trips, invoice)
      doc.save(`${filePrefix}${invoiceNo}_${invoiceFrom}_trips.pdf`)

      this.pdfInvoiceDialog = false
      return
    },

    compare(a, b) {
      if (a.id < b.id) return -1
      if (a.id > b.id) return 1
      return 0
    },
    sortTrips(a, b) {
      var vehicleName1 = a.docket
        ? a.docket.vehicle.name.toLowerCase()
        : a.trip.docket.vehicle.name.toLowerCase()
      var vehicleName2 = b.docket
        ? b.docket.vehicle.name.toLowerCase()
        : b.trip.docket.vehicle.name.toLowerCase()
      var date1 = a.docket ? a.docket.date : a.trip.docket.date
      var date2 = b.docket ? b.docket.date : b.trip.docket.date

      if (vehicleName1 < vehicleName2) return -1
      if (vehicleName1 > vehicleName2) return 1
      if (date1 < date2) return -1
      if (date1 > date2) return 1

      // if(!!a.docket.externalRef && b.docket.externalRef)
      var externalRef1 = a.docket
        ? a.docket.externalRef
        : a.trip.docket.externalRef
      var externalRef2 = b.docket
        ? b.docket.externalRef
        : b.trip.docket.externalRef

      // var externalRef1 = a.docket.externalRef;
      // var externalRef2 = b.docket.externalRef;
      if (externalRef1 < externalRef2) return -1
      if (externalRef1 > externalRef2) return 1
      return 0
    },

    async createTripsPdf(doc, trips, invoice) {
      var pageSize = doc.internal.pageSize
      var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()
      var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
      var totalPagesExp = '{total_pages_count_string}'
      trips.sort(this.sortTrips)
      var columns = [
        // {title: "Trip ID", dataKey: "id"},
        { title: 'Vehicle', dataKey: 'vehicleName' },
        { title: 'Date', dataKey: 'date' },
        { title: 'Docket', dataKey: 'externalRef' },
        { title: 'Site', dataKey: 'siteName' },
        { title: 'Spoil', dataKey: 'spoilName' },
        { title: 'Tip', dataKey: 'tipName' },
        { title: 'Type', dataKey: 'vehicleType' },
        // {title: "RCTI", dataKey: "rctiId"},
        { title: 'Qty', dataKey: 'qty' },
        { title: 'Hours', dataKey: 'hours' },
        { title: 'Mass', dataKey: 'siteWeight' }
        //{title: "Total", dataKey: "costTotal"},
      ]
      if (this.$route.name == 'billing') {
        if (invoice.isApproved) {
          columns.push({ title: 'Rate', dataKey: 'rate' })
          columns.push({ title: 'Total (exGST)', dataKey: 'amount' })
        } else {
          columns.push({ title: 'Total (exGST)', dataKey: 'sellTotalTemp' })
        }
        columns.unshift({ title: 'Inv.#', dataKey: 'billId' })
        columns.push({ title: 'Class', dataKey: 'vehicleClass' })
        columns.push({ title: 'Notes', dataKey: 'notes' })
        var name = `${invoice.client.name} - ${invoice.site.name}`
      }
      if (this.$route.name == 'rcti') {
        columns.unshift({ title: 'RCTI#', dataKey: 'rctiId' })

        columns.push({ title: 'Total (exGST)', dataKey: 'costTotalTemp' })
        columns.push({ title: 'Rate', dataKey: 'tripRate' })
        columns.push({ title: 'Notes', dataKey: 'notes' })

        var name = invoice.contractor.name
      }
      if (this.$route.name == 'docket') {
        columns.push({ title: 'RCTI', dataKey: 'rctiId' })
        columns.push({ title: 'Bill', dataKey: 'billId' })

        if (this.userShowCost) {
          columns.push({
            title: 'Cost Total (exGST)',
            dataKey: 'costTotalTemp'
          })
        }
        if (this.userShowSell) {
          columns.push({
            title: 'Sell Total (exGST)',
            dataKey: 'sellTotalTemp'
          })
        }
      }

      var tripsTotalHours = await this.calculateTotal(trips, 'hours')

      var tripsTotalSiteWeight = await this.calculateTotal(trips, 'siteWeight')
      doc.setFontSize(12)
      doc.setFontSize(18)

      var rows = trips.map(obj => {
        const tripObj = invoice && invoice.isApproved ? obj.trip : obj
        obj.date = this.makeShortDate(tripObj.docket.date)
        obj.externalRef = tripObj.docket.externalRef
        obj.projectName = tripObj.docket.site.project.name
        obj.siteName = tripObj.docket.site.name
        obj.spoilName = tripObj.spoil.name
        obj.driverName = tripObj.docket.driver.name
        obj.vehicleName = tripObj.docket.vehicle.name
        obj.vehicleType = tripObj.docket.vehicle.vehicleType.name
        obj.vehicleClass = tripObj.docket.vehicle.vehicleType.class
        obj.tripRate = `$${tripObj.costPrice} / ${tripObj.costUnit}`
        obj.tipName =
          this.$route.name == 'billing'
            ? !!tripObj.tip.number
              ? tripObj.tip.number
              : tripObj.tip.name
            : tripObj.tip.name
        obj.costTotalTemp =
          '$' + this.numberWithCommas(Number(tripObj.costTotal).toFixed(2))
        obj.sellTotalTemp =
          '$' + this.numberWithCommas(Number(tripObj.sellTotal).toFixed(2))

        if (invoice && invoice.isApproved) {
          obj.billId = obj.billLine.billId
          obj.amount = Number(obj.amount)
          obj.siteWeight = tripObj.siteWeight
          obj.hours = tripObj.hours
        } else {
          obj.rctiId = obj.rcti
            ? obj.rcti.externalRef
              ? obj.rcti.externalRef
              : obj.rctiId
            : obj.rctiId
        }
        return obj
      })
      //console.log("Trips: ",rows);
      rows = rows.filter(row => {
        if (this.$route.name == 'billing') {
          return row.sellTotal != 0
        } else if (this.$route.name == 'rcti') {
          return row.costTotal != 0
        } else {
          return true
        }
        //return this.$route.name == 'billing' ? row.sellTotal != 0 : row.costTotal != 0
      })
      //doc.setFontSize(18)
      //doc.text(40, 200, "Test", {align: "center"})
      doc.autoTable(columns, rows, {
        didDrawPage: data => {
          // Header
          doc.setFontSize(22)
          const pageTitle =
            invoice && invoice.isApproved ? 'Approved Bill Lines' : 'Trips'
          doc.text(pageWidth / 2, this.topOffset, pageTitle, {
            align: 'center'
          })
          doc.setFontSize(12)
          if (this.$route.name == 'docket') {
            if (this.pdfIncludeHoursMass) {
              doc.text(
                this.leftSide,
                this.topOffset + this.lineHeight * 3,
                `Mass: ${
                  tripsTotalSiteWeight == null
                    ? 0.0
                    : tripsTotalSiteWeight.toFixed(2)
                }`,
                { align: 'left' }
              )
              doc.text(
                this.leftSide,
                this.topOffset + this.lineHeight * 4,
                `Hours: ${
                  tripsTotalHours == null ? 0.0 : tripsTotalHours.toFixed(2)
                }`,
                { align: 'left' }
              )
            }
          }
          doc.setFontSize(20)
          doc.setTextColor(40)
          doc.setFontStyle('normal')
          // if (base64Img) {
          //     doc.addImage(base64Img, 'JPEG', data.settings.margin.left, 15, 10, 10);
          // }
          //doc.text("Report", data.settings.margin.left + 15, 22);
          doc.setFontSize(12)
          if (!!invoice) {
            doc.line(
              this.leftSide,
              this.topOffset + this.lineHeight * 4.5,
              this.rightSide,
              this.topOffset + this.lineHeight * 4.5
            )
            doc.text(
              this.leftSide,
              this.topOffset + this.lineHeight * 2,
              name,
              { align: 'left' }
            )
            doc.text(
              pageWidth - 40,
              this.topOffset + this.lineHeight * 2,
              `Invoice Date: ${this.makeShortDate(invoice.date)}`,
              { align: 'right' }
            )
          }
          doc.text(
            pageWidth - 40,
            this.topOffset + this.lineHeight * 3,
            `Date printed: ${this.makeShortDate(this.today)}`,
            { align: 'right' }
          )
          doc.text(
            pageWidth - 40,
            this.topOffset + this.lineHeight * 4,
            `Billing Period: ${this.billingPeriod}`,
            { align: 'right' }
          )
          doc.line(
            this.leftSide,
            this.topOffset + this.lineHeight * 4.5,
            pageWidth - 40,
            this.topOffset + this.lineHeight * 4.5
          )

          // Footer
          var str = 'Page ' + doc.internal.getNumberOfPages()
          // Total page number plugin only available in jspdf v1.0+
          if (typeof doc.putTotalPages === 'function') {
            str = str + ' of ' + totalPagesExp
          }
          doc.setFontSize(10)

          // jsPDF 1.4+ uses getWidth, <1.4 uses .width
          doc.text(str, data.settings.margin.left, pageHeight - 10)
        },
        theme: 'grid',
        showHead: 'everyPage',
        styles: { halign: 'left', fontSize: 8 },
        headStyles: { fillColor: [220, 220, 220], halign: 'center' },
        margin: {
          left: this.leftSide,
          top: this.topOffset + this.lineHeight * 5
        },
        columnStyles: {
          billId: { cellWidth: 40 },
          vehicleName: { cellWidth: 50 },
          date: { cellWidth: 60 },
          externalRef: { cellWidth: 50 },
          tipName: { cellWidth: 40 },
          costTotalTemp: { halign: 'right' },
          sellTotalTemp: { halign: 'right', cellWidth: 50 },
          amount: { halign: 'right', cellWidth: 50 },
          rateId: { halign: 'right' },
          qty: { halign: 'right', cellWidth: 40 },
          hours: { halign: 'right' },
          siteWeight: { halign: 'right', cellWidth: 40 },
          vehicleClass: { cellWidth: 45 },
          notes: { cellWidth: 80 }
        }
      })
      if (typeof doc.putTotalPages === 'function') {
        doc.putTotalPages(totalPagesExp)
      }
      return doc
    },

    getDocketIds(trips) {
      var tripSubjects = []
      for (var trip of trips) {
        var docketId = trip.docketId
        if (!(tripSubjects.indexOf(docketId) > -1)) {
          tripSubjects.push(docketId)
        }
      }
      return tripSubjects
    },

    calculateTotal(array, prop) {
      return this.$worker.run(
        (array, prop) => {
          var total = 0
          for (var row of array) {
            if (!!row[prop]) {
              var number = Number(row[prop])
              total += number
            }
          }
          return total
        },
        [array, prop]
      )
    }
  },
  props: {
    page: String,
    selectedCount: Number,
    pagination: Object,
    docketAdjustment: Object
  },
  computed: {
    billingPeriod: Store.getSet({ store: 'shared', prop: 'billingPeriod' }),
    pdfInvoiceDialog: Store.getSet({
      store: 'shared',
      prop: 'pdfInvoiceDialog'
    }),
    pdfDialog: Store.getSet({ store: 'shared', prop: 'pdfDialog' }),
    selected: {
      get() {
        return this.$store.state[this.page].selected
      },
      set(val) {
        this.$store.commit(`${this.page}/setState`, {
          prop: 'selected',
          value: val
        })
      }
    },
    selectedAll() {
      return this.$store.state[this.page].selectedAll
    },
    centerAlign() {
      return this.rightSide / 2 + this.leftSide
    }
  }
}
</script>

<style>
</style>
